module.exports = __webpack_public_path__ + "static/media/dhost.3e0d974a.svg";